import { render, staticRenderFns } from "./updateOperatorLinkageRiskWeight.vue?vue&type=template&id=2404299f&lang=pug"
import script from "./updateOperatorLinkageRiskWeight.vue?vue&type=script&lang=js"
export * from "./updateOperatorLinkageRiskWeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports